import { LucideIcon } from 'lucide-react'

interface PageHeaderProps {
  icon: LucideIcon
  iconColor?: string
  title: string
  description: string
}

export const PageHeader = ({
  icon: Icon,
  iconColor = 'text-background',
  title,
  description
}: PageHeaderProps) => {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center">
      <div className="bg-primary flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full">
        <Icon className={`h-6 w-6 ${iconColor}`} />
      </div>
      <div className="min-w-0">
        <h1 className="text-xl font-bold md:text-2xl">{title}</h1>
        <p className="text-muted-foreground text-sm md:text-base">{description}</p>
      </div>
    </div>
  )
}
